.item {
  width: 100%;
  transition: all 0.1s ease-in;
  user-select: none;
  display: flex;
  align-items: center;
  color: var(--color-grayscale-shuttle, #626878);
  gap: 0.8rem;

  @media (max-width: #{$bp-medium - 1}) {
    border-radius: 0.4rem;
    cursor: pointer;

    &:hover {
      background-color: var(--color-surface-further);
      color: var(--color-grayscale-anti-flash-white, #f2f3f5);

      svg {
        color: var(--color-grayscale-anti-flash-white, #f2f3f5);
        fill: var(--color-grayscale-manatee, #959bab);
      }
    }

    &[data-active='true'] {
      background: var(--color-surface-further);
    }
  }

  &[data-disabled='true'] {
    display: none;
  }
}

.icon {
  color: var(--text-color-white);
  font-size: 1.6rem;
  font-weight: 500;
  height: 3.2rem;
  width: 3.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.4rem;
  cursor: pointer;

  /* `background` was inside this media query in the styled-components version,
     so the [data-current] override has to stay inside it too — hoisting it to
     the class root would apply the highlight below the breakpoint as well. */
  @media (min-width: #{$bp-medium - 1}) {
    background: transparent;

    &[data-current='true'] {
      background: var(--color-grayscale-tuna, #31343c);
    }
  }

  svg {
    color: var(--color-grayscale-shuttle, #626878);
    fill: var(--color-grayscale-arsenic, #3c404a);
  }

  /* Targets the child svg, not this element: the original interpolated
     `color`/`fill` inside the nested `svg` rule. */
  &[data-current='true'] svg {
    color: var(--color-grayscale-anti-flash-white, #f2f3f5);
    fill: var(--color-grayscale-manatee, #959bab);
  }

  &:hover {
    background: var(--color-grayscale-tuna, #31343c);
    color: var(--color-grayscale-anti-flash-white, #f2f3f5);

    svg {
      color: var(--color-grayscale-anti-flash-white, #f2f3f5);
      fill: var(--color-grayscale-manatee, #959bab);
    }
  }
}

.name {
  font-size: 1.2rem;
  font-weight: 500;
  font-family: inherit;
}

.notification {
  color: var(--text-color-white);
  background: var(--color-primary);
  font-size: 1rem;
  font-weight: 500;
  border-radius: 0.4rem;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 1.6rem;
  height: 1.6rem;
}
